import { callServerApiAsync } from "system/servercall";
import { GUIDELINES } from 'feature/question/community-guidelines';
import { labelToKey, type Feature } from "util/stdtypes";
import type { Comment, CommentConfig } from "component/comment";
import type { Datastore } from "util/datastore";
import type { ModerationConfig, ModerationResult } from "feature/moderation/ai-premoderator";

export const BlocklistFeature: Feature<ModerationConfig & CommentConfig, {}> = {
    name: 'Blocklist',
    key: 'blocklist',
    providesConfig: {
        commentModerators: [checkBlocklistAsync],
    }
};

async function checkBlocklistAsync(datastore: Datastore, comment: Comment, questionText: string): Promise<ModerationResult> {
    if (!comment.text?.trim()) {
        return { violates: false, allow: true, commentProps: { violates: false, inReview: false } };
    }

    const moderationResult = await callServerApiAsync({
        datastore,
        component: "blocklist",
        funcname: "checkBlocklist",
        params: {
            text: comment.text,
        },
    });

    if (moderationResult.violates) {
        return {
            violates: true,
            source: "blocklist",
            // TODO: Listing a specific community guideline doesn't quite fit for a blocklist violation
            violations: [labelToKey(GUIDELINES.NO_UNCIVIL)],
            metadata: { blocklistedTerm: moderationResult.blocklistedTerm }
        };
    } else {
        return { violates: false, metadata: null };
    }
}